import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AppareilDisplay from './AppareilDisplay';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const VIEWMODE_LIST = 0;
const VIEWMODE_DETAIL = 1;
const { REACT_APP_PROXY_HOST } = process.env;

const useStyles = makeStyles((theme) => ({
  root: { width: '100%' },
  paper: { marginTop: theme.spacing(3), width: '100%', overflowX: 'auto', marginBottom: theme.spacing(2) },
  table: { minWidth: 650 },
}));

const AppareilList = () => {
  const [activeAppareil, setActiveAppareil] = useState('');
  const [appareils, setAppareils] = useState([]);
  const [viewMode, setViewMode] = useState(VIEWMODE_LIST);
  const [camIdSearch, setCamIdSearch] = useState('');
  const location = useLocation();
  const classes = useStyles();

  useEffect(() => {
    fetch(REACT_APP_PROXY_HOST + '/liste/appareils', { method: 'GET' })
      .then((res) => res.json())
      .then((resAppareils) => setAppareils(resAppareils));
  }, []);

  useEffect(() => {
    if (!appareils || appareils.length === 0) {
      return;
    }

    const params = new URLSearchParams(location.search);
    const selectedTelId = params.get('telId');
    if (!selectedTelId) {
      return;
    }

    const found = appareils.find((appareil) => String(appareil.telId) === String(selectedTelId));
    if (found) {
      setActiveAppareil(found);
      setViewMode(VIEWMODE_DETAIL);
    }
  }, [location.search, appareils]);

  function changeViewMode(mViewMode, appareil) {
    setViewMode(mViewMode);
    setActiveAppareil(appareil);
  }

  const renderDetails = () => (
    <div>
      <Button variant="contained" onClick={() => changeViewMode(VIEWMODE_LIST, '')}>Voir Liste</Button>
      <h1>Appareil</h1>
      <AppareilDisplay
        _id={activeAppareil.telId}
        battery={activeAppareil.batterie}
        lastUpdate={activeAppareil.dernierMaJ}
        telId={activeAppareil.telId}
        camId={activeAppareil.camId}
        temperature={activeAppareil.temperature}
        statusCode={activeAppareil.codeEtat}
        version={activeAppareil.version}
        viewMode={VIEWMODE_DETAIL}
      />
    </div>
  );

  const displayCond = (id2check, camId2check) => {
    if (camId2check.camIdSearch === '' || (id2check + '').includes(camId2check.camIdSearch + '')) {
      return true;
    }
    return false;
  };

  const renderListElements = () => (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <h1>Appareils</h1>
        <Table className={classes.table} size="small">
          <TableHead>
            <TableRow>
              <TableCell onClick={() => { const sorted = [...appareils].sort((a, b) => (a.camId + '').localeCompare(b.camId + '')); setAppareils(sorted); }}>Cam Id</TableCell>
              <TableCell align="right">Telephone Id</TableCell>
              <TableCell align="right" onClick={() => { const sorted = [...appareils].sort((a, b) => a.dernierMaJ.localeCompare(b.dernierMaJ)); setAppareils(sorted); }}>Derniere mise a jour</TableCell>
              <TableCell align="right" onClick={() => { const sorted = [...appareils].sort((a, b) => a.batterie - b.batterie); setAppareils(sorted); }}>Niveau de batterie</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell><input type="text" value={camIdSearch} onChange={(e) => setCamIdSearch(e.target.value)} /></TableCell>
              <TableCell align="right"><input type="text" /></TableCell>
              <TableCell align="right"><input type="text" /></TableCell>
              <TableCell align="right"><input type="text" /></TableCell>
            </TableRow>
            {appareils.map((appareil) => (
              displayCond(appareil.camId, { camIdSearch }) ? (
                <TableRow key={appareil.telId} onClick={() => changeViewMode(VIEWMODE_DETAIL, appareil)}>
                  <TableCell component="th" scope="row">{appareil.camId}</TableCell>
                  <TableCell align="right">{appareil.telId}</TableCell>
                  <TableCell align="right">{appareil.dernierMaJ}</TableCell>
                  <TableCell align="right">{appareil.batterie}</TableCell>
                </TableRow>
              ) : null
            ))}
          </TableBody>
        </Table>
      </Paper>
    </div>
  );

  return <div>{viewMode === VIEWMODE_DETAIL ? renderDetails() : renderListElements()}</div>;
};

export default AppareilList;



// WEBPACK FOOTER //
// src/components/appareils/AppareilList.js